// @flow
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import PatternService from '../../services/pattern';
import Loader from '../Loader/Loader';
import PinItButton from '../PinItButton/PinItButton';
import './PatternDetail.css';


export default class PatternDetail extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentIndex: 0,
            queue: [],
            isLoading: false,
            size: {
                width: null,
                height: null,
            },
        };

        this.patternService = new PatternService();

        // -- binding event handlers
        this.move = this.move.bind(this);
        this.moveLeft = this.moveLeft.bind(this);
        this.moveRight = this.moveRight.bind(this);
        this.close = this.close.bind(this);
        this.resize = this.resize.bind(this);
        this.handleKeyEvent = this.handleKeyEvent.bind(this);
    }


    componentDidMount() {
        document.body.style.overflow = "hidden";
        window.addEventListener('resize', this.resize);
        window.addEventListener('keydown', this.handleKeyEvent);

        this.patternService.get(this.props.id).then((pattern) => {

            let queue = [pattern];
            pattern.mockups.forEach(mockup => {
                queue.push(mockup);
            });

            let currentIndex = 0;
            if (this.props.mid !== 'null') {
                let mid = parseInt(this.props.mid, 10);

                currentIndex = queue.slice(1).findIndex(m => {
                    return m.id === mid;
                });

                currentIndex = currentIndex === -1 ? 0 : currentIndex + 1;
            }

            setTimeout(() => {
                this.setState(() => ({
                    currentIndex: currentIndex,
                    queue: queue,
                }));

            }, 500);

        });
    }


    componentWillUnmount() {
        document.body.style.overflow = "auto";
        window.removeEventListener('resize', this.resize);
        window.removeEventListener('keydown', this.handleKeyEvent);
    }


    close () {
        this.props.history.push('/patterns');
    }


    moveLeft (event) {
        if (event) {
            event.stopPropagation();

        }

        if (this.state.currentIndex === 0 ||
                this.state.isLoading) {
            return;
        }

        this.setState(prevState => {
            this.refreshUrl(prevState.currentIndex - 1);

            return {
                currentIndex: prevState.currentIndex - 1,
                isLoading: true,
            };
        });

    }


    moveRight (event) {
        if (event) {
            event.stopPropagation();

        }

        if (this.state.currentIndex === this.state.queue.length - 1 ||
                this.state.isLoading) {
            return;
        }

        this.setState(prevState => {
            this.refreshUrl(prevState.currentIndex + 1);

            return {
                currentIndex: prevState.currentIndex + 1,
                isLoading: true,
            };
        });
    }


    move (event) {
        event.stopPropagation();

        let box = event.target.getBoundingClientRect();
        let normX = event.clientX - box.x;
        let delta = 0.45;

        if (normX <= delta * box.width) {
            this.moveLeft();

        } else if (normX > (1 - delta) * box.width){
            this.moveRight();

        }

    }

    refreshUrl (nextIndex) {
        let uri;

        if (nextIndex === 0) {
            uri = `/patterns/?id=${this.props.id}&mid=null`;

        } else {
            let current = this.state.queue[nextIndex];
            uri = `/patterns/?id=${this.props.id}&mid=${current.id}`;

        }

        this.props.history.push(uri);
    }


    handleKeyEvent (event) {
        const KEY_LEFT = 37;
        const KEY_RIGHT = 39;
        const ESC = 27;

        switch (event.keyCode) {
            case KEY_LEFT:
                this.moveLeft();
                break;

            case KEY_RIGHT:
                this.moveRight();
                break;

            case ESC:
                this.close();
                break;

            default:
                break;
        }

    }


    handleImageLoaded (event) {
        this.setState({ isLoading: false });
        this.positionButtons(event.target);
    }


    resize () {
        if (this.imgEl) {
            this.positionButtons(this.imgEl);
        }
    }


    positionButtons (el) {
        let w = el.clientWidth,
            h = el.clientHeight;

        // -- position navigation buttons
        this.navigateBtns.style.transform = `translateY(${ 0.5 * h - 60}px)`;
        this.navigateBtns.style.display = 'block';

        // -- position close button
        this.closeBtn.style.transform = (
            `translate(${ 0.5 * w - 60 }px, -${ 0.5 * h - 10 }px)`);
        this.closeBtn.style.display = 'block';

        this.setState({
            size: {
                width: w,
                height: h,
            },
        });
    }


    render () {
        if (this.state.queue.length === 0) {
            return (
                <div
                    className="ln-detail">
                    <Loader />
                </div>
            );
        }

        let current = this.state.queue[this.state.currentIndex],
            leftArrowCssClass = '',
            rightArrowCssClass = '',
            loader,
            pinItButton;

        if (this.state.isLoading) {
            loader = <Loader />;
        }

        if (this.state.currentIndex === 0) {
            leftArrowCssClass = 'ln-disabled';
        }

        if (this.state.currentIndex === this.state.queue.length - 1) {
            rightArrowCssClass = 'ln-disabled';

        }

        if (this.state.size.width && this.state.size.height) {

            pinItButton = (
                <PinItButton
                    width={ this.state.size.width }
                    height={ this.state.size.height }
                    description={ current.title_pl }
                    imgUrl={ current.image_uri } />);
        }

        return (
            <div
                className="ln-detail">
                { loader }

                <div
                    onClick={ this.close }
                    className="ln-detail-inner">

                    <div
                        className="ln-image">

                        <img
                            onClick={ this.move }
                            ref={(el) => { this.imgEl = el; }}
                            onLoad={this.handleImageLoaded.bind(this)}
                            src={ current.image_uri }
                            alt={ current.title_pl } />

                        { pinItButton }

                        <div
                            ref={(el) => { this.closeBtn = el; }}
                            className="ln-close">
                            <span
                                className="icon-cancel">
                                <Link to="/patterns"></Link>
                            </span>

                        </div>
                        <div
                            ref={(el) => { this.navigateBtns = el; }}
                            className="ln-buttons">

                            <span
                                className={ 'ln-arrow icon-left-open ' + leftArrowCssClass }
                                onClick={ this.moveLeft }>
                            </span>
                            <span
                                className="ln-counter">
                                { this.state.currentIndex + 1 } / { this.state.queue.length }
                            </span>
                            <span
                                className={ 'ln-arrow icon-right-open ' + rightArrowCssClass }
                                onClick={ this.moveRight }>
                            </span>

                        </div>

                    </div>

                </div>

            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/PatternDetail/PatternDetail.js